angular.module('nv.SchoolMetricsModule').component('creditMetrics', {
  template: require('./views/credit-table.html'),
  bindings: {
    currentSchool: '<',
  },
  controller: 'CreditMetricsCtrl',
});
